export { Cake as default } from './Cake';
